import gql from 'graphql-tag';

// Company settings for Employee Voices and HR Practices
export const GET_COMPANY_SETTINGS = gql`
  query GetCompanySettings($data: String!) {
    getCompanySettings(companyId: $data) {
      id
      key
      type
      value
    }
  }
`;

// HR Practices: list all practices for a company
export const LIST_PRACTICE_QUERY = gql`
  query ListPractice($companyId: String!) {
    listPractice(companyId: $companyId) {
      id
      companyId
      title
      shortDescription
      description
      introDescription
      shortName
      iconUrl
      illustrationUrl
      outroIllustrationUrl
      successOutroTitle
      status
      state
      setupProgress
      survey {
        id
        type
        completedAt
      }
    }
  }
`;

// HR Practices: get a single practice with survey details
export const GET_PRACTICE_QUERY = gql`
  query GetPractice($input: GetPracticeInput!) {
    getPractice(input: $input) {
      id
      companyId
      title
      shortDescription
      description
      introDescription
      shortName
      iconUrl
      illustrationUrl
      outroIllustrationUrl
      successOutroTitle
      status
      state
      setupProgress
      survey {
        id
        type
        completedAt
        questions
        answers
      }
    }
  }
`;

// HR Score for a company (enum)
export const GET_HR_SCORE_QUERY = gql`
  query GetHrScore($companyId: String!) {
    getHrScore(companyId: $companyId)
  }
`;

// Company survey for a specific practice/type
export const GET_SURVEY_QUERY = gql`
  query GetCompanySurvey($data: GetCompanySurveyInput!) {
    companySurvey(data: $data) {
      id
      type
      completedAt
      questions
      answers
    }
  }
`;

// Save a single survey answer
export const SAVE_COMPANY_ANSWER_MUTATE = gql`
  mutation SaveCompanyAnswer($data: SaveCompanyAnswerInput!) {
    saveCompanyAnswer(data: $data) {
      id
      type
      completedAt
      questions
      answers
    }
  }
`;

// Complete a company survey
export const COMPLETE_COMPANY_SURVEY_MUTATE = gql`
  mutation CompleteCompanySurvey($data: CompleteCompanySurveyInput!) {
    completeCompanySurvey(data: $data) {
      id
      type
      completedAt
    }
  }
`;

// Mark a practice as completed
export const COMPLETE_COMPANY_PRACTICE_MUTATE = gql`
  mutation CompleteCompanyPractice($data: CompletePracticeInput!) {
    completeCompanyPractice(data: $data) {
      id
      status
      state
    }
  }
`;

// Basic company info (core)
export const GET_BASIC_COMPANY_INFO = gql`
  query GetBasicCompanyInfo($id: ID!) {
    coreCompany(id: $id) {
      id
      name
      industry
      phone
    }
  }
`;

export const UPDATE_BASIC_COMPANY_INFO = gql`
  mutation UpdateBasicCompanyInfo($data: UpdateCoreCompanyInput!) {
    updateCoreCompany(data: $data) {
      id
      name
      industry
      phone
    }
  }
`;

// Simple policy list used by setup wizard
export const GET_SIMPLE_POLICY_LIST = gql`
  query GetSimplePolicyList($companyId: ID!) {
    getCoreCompany(id: $companyId) {
      policies(
        limit: 200
        page: 1
        status: ["in-progress", "approved", "complete"]
      ) {
        id
        name
        isCPD
        archivedAt
        status
        step
      }
    }
  }
`;

// Save company setting (cadence etc.)
export const SAVE_COMPANY_SETTING = gql`
  mutation SaveCompanySetting($input: SaveCompanySettingInput!) {
    saveCompanySetting(input: $input) {
      id
      companyId
      key
      type
      value
    }
  }
`;

// Bulk message staff
export const BULK_MESSAGE_STAFF = gql`
  mutation BulkMessageStaff($data: BulkMessageStaffInput!) {
    bulkMessageStaff(data: $data) {
      successfulStaffIds
      errors {
        staffId
        errorMsg
      }
    }
  }
`;
